import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '../views/Main.vue'
import wxUtils from '@/utils/weixin/utils'
import { share } from '@/mixins/weixin'
import * as Cookie from '@/utils/cookie'
import { Toast } from 'vant'

Vue.use(VueRouter)

// disableShare Boolean 是否配置对应source默认分享信息
// hideShare Boolean 是否隐藏基础传播按钮
// hideShareRule Function 判断是否隐藏基础传播按钮的函数
const routes = [{
    // 朝阳首页
    path: '/quiz',
    name: 'main',
    component: Main
}, {
    // 朝阳日常
    path: '/quiz/daily',
    name: 'daily',
    component: () => import('../views/Daily'),
    meta: {
        hideShare: false
    }
}, {
    // 朝阳挑战
    path: '/quiz/challenge',
    name: 'challenge',
    component: () => import('../views/Challenge')
}, {
    // 朝阳求助
    path: '/quiz/help/:resultId',
    name: 'help',
    component: () => import('../views/Help'),
}, {
    // 朝阳兑奖
    path: '/quiz/exchange',
    name: 'exchange',
    component: () => import('../views/Exchange')
}, {
    // 朝阳兑奖参与奖
    path: '/quiz/exchange/participant',
    name: 'exchangeParticipant',
    component: () => import('../views/Exchange/Participant')
}, {
    // 朝阳规则
    path: '/quiz/rules/:ruleName',
    name: 'rules',
    component: () => import('../views/Rules'),
    meta: {
        hideShareRule: (to) => ['agriScore', 'agriActivity'].indexOf(to.params?.ruleName) !== -1,
    }
}, {
    // 朝阳个人中心
    path: '/quiz/me',
    name: 'me',
    component: () => import('../views/Me')
}, {
    // 朝阳学习园地
    path: '/quiz/articleList',
    name: 'articleList',
    component: () => import('../views/ArticleList'),
    meta: {
        hideShare: true,
    }
}, {
    // 朝阳用户信息
    path: '/quiz/me/info',
    name: 'myInfo',
    component: () => import('../views/Me/Info')
}, {
    // 朝阳-农业 排行榜
    path: '/quiz/top',
    name: 'top',
    component: () => import('../views/Top'),
    meta: {
        hideShareRule: (to) => to.query?.source === 'agriculture'
    }
}, {
    // 农业部首页
    path: '/quiz/agriculture',
    name: 'agriMain',
    component: () => import('../views/Agri/Main'),
    meta: {
        source: 'agriculture'
    }
}, {
    // 农业部每日答题
    path: '/quiz/agriculture/daily',
    name: 'agriDaily',
    component: () => import('../views/Agri/Daily'),
    meta: {
        source: 'agriculture'
    }
}, {
    // 农业部挑战
    path: '/quiz/agriculture/challenge',
    name: 'agriChallenge',
    component: () => import('../views/Agri/Challenge'),
    meta: {
        source: 'agriculture'
    }
}, {
    // 农业部求助
    path: '/quiz/agriculture/help/:resultId',
    name: 'agriHelp',
    component: () => import('../views/Agri/Help'),
    meta: {
        source: 'agriculture'
    }
}, {
    // 农业部文章分类
    path: '/quiz/agriculture/articleClassify',
    name: 'articleClassify',
    component: () => import('../views/Agri/ArticleClassify'),
    meta: {
        hideShare: true,
        source: 'agriculture'
    }
}, {
    // 农业部文章列表
    path: '/quiz/agriculture/articleList/:listName',
    name: 'articleList',
    component: () => import('../views/Agri/ArticleList'),
    meta: {
        hideShare: true,
        source: 'agriculture'
    }
}, {
    // 农业部文章
    path: '/quiz/agriculture/articles/:articleId',
    name: 'article',
    component: () => import('../views/Agri/Article'),
    meta: {
        source: 'agriculture',
        disabledShare: true,
    }
}, {
    // 农业部个人中心
    path: '/quiz/agriculture/me',
    name: 'me_agri',
    component: () => import('../views/Agri/Me'),
    meta: {
        source: 'agriculture',
        hideShare: true
    }
}, {
    // 农业部规则
    path: '/quiz/agriculture/rules/:ruleName',
    name: 'agriRules',
    component: () => import('../views/Agri/Rules'),
    meta: {
        source: 'agriculture',
        hideShare: true
    }
}, {
    // 农业兑奖
    path: '/quiz/agriculture/exchange',
    name: 'exchange',
    component: () => import('../views/Agri/Exchange'),
    meta: {
        source: 'agriculture',
    }
}, {
    // 网信办首页
    path: '/cac',
    name: 'cacMain',
    component: () => import('../views/Cac'),
    meta: {
        source: 'cac'
    }
}, {
    // 网信办日常答题
    path: '/cac/daily',
    name: 'cacDaily',
    component: () => import('../views/Cac/Daily'),
    meta: {
        source: 'cac',
    }
}, {
    // 网信办答题结果
    path: '/cac/result/:result_id',
    name: 'cacResult',
    component: () => import('../views/Cac/Res'),
    meta: {
        source: 'cac',
    }
}, {
    // 网信办解析页
    path: '/cac/analysis/:result_id',
    name: 'cacAnalysis',
    component: () => import('../views/Cac/Analysis'),
    meta: {
        source: 'cac'
    }
}, {
    // 新首页
    path: '/icif',
    name: 'icifMain',
    component: () => import('../views/Icif'),
    meta: {
        disabledShare: true,
        source: 'icif'
    }
}, {
    // 新日常答题
    path: '/icif/daily',
    name: 'icifDaily',
    component: () => import('../views/Icif/Daily'),
    meta: {
        disabledShare: true,
        source: 'icif',
    }
}, {
    // 新答题结果
    path: '/icif/result/:result_id',
    name: 'icifResult',
    component: () => import('../views/Icif/Res'),
    meta: {
        disabledShare: true,
        source: 'icif',
    }
}, {
    // 新解析页
    path: '/icif/analysis/:result_id',
    name: 'icifAnalysis',
    component: () => import('../views/Icif/Analysis'),
    meta: {
        disabledShare: true,
        source: 'icif'
    }
}, {
    // 农业大屏首页
    path: '/aola',
    name: 'aolaMain',
    component: () => import('../views/Aola'),
    meta: {
        disabledShare: true,
        source: 'aola'
    }
}, {
    // 农业大屏日常答题
    path: '/aola/daily',
    name: 'aolaDaily',
    component: () => import('../views/Aola/Daily'),
    meta: {
        disabledShare: true,
        source: 'aola',
    }
}, {
    // 农业大屏答题结果
    path: '/aola/result/:result_id',
    name: 'aolaResult',
    component: () => import('../views/Aola/Res'),
    meta: {
        disabledShare: true,
        source: 'aola',
    }
}, {
    // 农业大屏解析页
    path: '/aola/analysis/:result_id',
    name: 'aolaAnalysis',
    component: () => import('../views/Aola/Analysis'),
    meta: {
        disabledShare: true,
        source: 'aola'
    }
}, {
    // 退出登录
    path: '/quiz/logout',
    name: 'logout'
}]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.afterEach((to) => {
    const {
        hideShare = false,
        hideShareRule,
        source = 'sun',
        disabledShare = false
    } = to.meta || {}

    if (hideShare || (hideShareRule && hideShareRule(to))) wxUtils.hideAllNonBaseMenuItem()
    else wxUtils.showAllNonBaseMenuItem()

    !disabledShare && share({}, source)

    Vue.prototype.GLOBAL.source = to.meta.source || to.query.source || 'sun'

    if (to.name === 'logout') {
        Cookie.remove('uid')
        Cookie.remove('access_token')
        Toast('退出登录成功')
    }
})

export default router
